class VirtualConsultation extends HTMLElement {
  constructor() {
    super();
    this.setupFadeIn();
  }

  connectedCallback() {
    this.toggle();
    this.setupCloseButton();
    this.setupOutsideClick();
  }

  setupFadeIn() {
    const delay = parseInt(this.getAttribute('data-delay'));
    setTimeout(() => {
      this.classList.add('visible');
    }, delay);
  }

  toggle() {
    const closeButton = document.getElementById('close-button');
    const chevron = this.querySelector('.chevron-collapse');

    this.addEventListener('click', (e) => {
      e.stopPropagation();
      this.classList.toggle('active');
      chevron.classList.toggle('active');
      closeButton.classList.toggle('visible');
    });
  }

  setupOutsideClick() {
    document.addEventListener('click', (e) => {
      if (this.classList.contains('active') && !this.contains(e.target)) {
        this.classList.remove('active');
        document.getElementById('close-button').classList.remove('visible');
      }
    });
  }

  setupCloseButton() {
    const closeButton = document.getElementById('close-button');

    closeButton.addEventListener('click', (e) => {
      e.stopPropagation();
      this.classList.add('closing');
      closeButton.classList.remove('visible');
      setTimeout(() => {
        this.remove();
      }, 500);
    });
  }
}

customElements.define('virtual-consultation', VirtualConsultation);
